
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rangeclaim",
      function () {
        return require("private-next-pages/rangeclaim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rangeclaim"])
      });
    }
  